export { matchers } from './client-matchers.js';

			export const nodes = [() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13')];

			export const server_loads = [];

			export const dictionary = {
	"": [2],
	"color-ramp-builder": [3],
	"distortion-correction": [4],
	"noise-signature": [5],
	"normal-map-composer": [6],
	"normal-map-filter": [7],
	"reverse-color-ramp": [8],
	"seamless-stitcher": [9],
	"seamless-tile-maker": [10],
	"single-channel-compressor": [11],
	"spectral-noise-playground": [12],
	"svg-path-editor": [13]
};

			export const hooks = {
				handleError: (({ error }) => { console.error(error) }),
			};